/**
 * Formateo unificado de errores SAT (documentos + CFDI).
 */

function _firstBatchNestedError(err) {
  const batchErrors = err?.batch_errors;
  if (!Array.isArray(batchErrors) || !batchErrors.length) return null;
  const nested = batchErrors[0]?.error;
  return nested && typeof nested === "object" ? nested : null;
}

export function formatSatTechnicalError({
  failurePhase,
  satCodigo,
  satHint,
  userMessage,
  fallbackMessage,
} = {}) {
  const parts = [];
  if (failurePhase) parts.push(`Fase: ${failurePhase}`);
  if (satCodigo) parts.push(`Código: ${satCodigo}`);
  const msg = userMessage || satHint || fallbackMessage;
  if (msg) parts.push(`Mensaje: ${msg}`);
  return parts.join(", ");
}

/**
 * Normaliza error desde job Mongo o respuesta API.
 */
export function resolveSatJobError(source) {
  const err = source?.error && typeof source.error === "object" ? source.error : source;
  if (!err || typeof err !== "object") {
    return {
      userMessage: typeof err === "string" ? err : "",
      satHint: null,
      failurePhase: source?.failure_phase || null,
      satCodigo: source?.sat_codigo || null,
      technicalSummary: "",
      code: "",
      batchErrors: [],
    };
  }
  const nested = _firstBatchNestedError(err);
  const detail = nested || err;
  const failurePhase = source?.failure_phase || err.failure_phase || detail.failure_phase || err.phase || null;
  const satCodigo = source?.sat_codigo || err.sat_codigo || detail.sat_codigo || null;
  const satMensaje = source?.sat_mensaje || err.sat_mensaje || detail.sat_mensaje || null;
  const satHint = source?.sat_hint || err.sat_hint || detail.sat_hint || err.hint || null;
  const userMessage =
    detail.user_message ||
    err.user_message ||
    (err.code === "SAT_BATCH_ALL_FAILED" ? err.message : "") ||
    detail.message ||
    err.message ||
    "";
  const code = err.code || detail.code || "";
  const technicalSummary = formatSatTechnicalError({
    failurePhase,
    satCodigo,
    satHint,
    userMessage,
    fallbackMessage: err.summary,
  });
  return {
    userMessage,
    satMensaje,
    satHint,
    failurePhase,
    satCodigo,
    technicalSummary,
    code,
    batchErrors: Array.isArray(err.batch_errors) ? err.batch_errors : [],
  };
}
